<template>
  <Headline
    tag="h4"
    :size="size"
    :badge="badge"
    class="tracking-wide"
    data-test-id="filter-group-headline"
  >
    {{ label }}
    <template #badge="{ badge: number }">
      <span
        v-if="number && +number > 0"
        class="ml-1 bg-black px-2 py-1 text-xs leading-3 text-white"
      >
        {{ number }}</span
      >
    </template>
  </Headline>
</template>

<script lang="ts">
import Headline from '#layers/base/components/ui/headlines/Headline.vue'

export default defineComponent({
  name: 'FilterGroupHeadline',
  components: {
    Headline,
  },
  props: {
    size: {
      type: String as PropType<string>,
      default: 'xs',
      validator: (val: string) =>
        ['2xl', 'xl', 'lg', 'base', '2sm', 'sm', 'xs'].includes(val),
    },
    label: {
      type: String as PropType<string>,
      default: '',
    },
    badge: {
      type: Number as PropType<number>,
      default: 0,
    },
  },
  setup() {},
})
</script>
